<template>
  <!-- HOTELERÍA -->
  <div class="hoteleria">
    <div class="hoteleria__fondo">
      <div class="container-fluid hoteleria__container">
        <div class="row hoteleria__row justify-content-center">
          <div
            class="
              col-lg-11 col-md-11 col-sm-11 col-11
              hoteleria__col hoteleria__col--titulo
              text-start
              pt-3
              mb-0
              px-2
            "
          >
            <h1 class="hoteleria__h1 mb-0" :style="{ color: colorPrimario }">
              Hotelería
            </h1>
            <router-link
              to="/home"
              class="hoteleria__link-home"
              aria-label="Acceder a este hoteleria"
              :style="{ color: colorPrimario }"
            >
              <IconHome  />
              Volver al Home
            </router-link>
            <p class="hoteleria__subtitulo mt-2">
              ¡Disfruta los beneficios que tenemos para ti y tu familia!
              Conócelos y solicítalos aquí.
            </p>
          </div>
          <div class="col-11 hoteleria__col">
            <hr class="hoteleria__hr" />
          </div>
        </div>
        <div class="row hoteleria__row justify-content-center">
          <div class="col-lg-11 col-md-11 col-sm-11 col-11 hoteleria__col">
            <div class="row hoteleria__row hoteleria__row-tarjetas">
              <!-- Loop de tarjeta de hoteleria -->
              <div
                class="
                  col-lg-3 col-md-4 col-sm-6 col-12
                  hoteleria__col
                  px-4
                  mb-2
                "
              >
                <router-link
                  to="/hoteleria/solicitudes"
                  class="hoteleria__link"
                >
                  <div class="row hoteleria__row">
                    <div
                      @mouseover="updateHoverState('1')"
                      @mouseleave="updateHoverState('')"
                      :style="{
                        'background-color':
                          hovered_id == '1' ? colorPrimario : '#fff',
                      }"
                      class="col-12 text-start hoteleria__cuadro-link px-3 py-4"
                    >
                      <p class="hoteleria__titulo-link mb-0">Solicitudes</p>
                      <p class="hoteleria__texto-link mb-1">
                        Reclamos o reportes del servicio recibido
                      </p>
                    </div>
                  </div>
                </router-link>
              </div>
              <div
                class="
                  col-lg-3 col-md-4 col-sm-6 col-12
                  hoteleria__col
                  px-4
                  mb-2
                "
              >
                <router-link to="/hoteleria" class="hoteleria__link">
                  <div class="row hoteleria__row">
                    <div
                      class="col-12 text-start hoteleria__cuadro-link px-3 py-4"
                      @mouseover="updateHoverState('2')"
                      @mouseleave="updateHoverState('')"
                      :style="{
                        'background-color':
                          hovered_id == '2' ? colorPrimario : '#fff',
                      }"
                    >
                      <p class="hoteleria__titulo-link mb-0">
                        Reglas campamento
                      </p>
                      <p class="hoteleria__texto-link mb-1">
                        Reglamento interno y tips de convivencia
                      </p>
                    </div>
                  </div>
                </router-link>
              </div>
              <div
                class="
                  col-lg-3 col-md-4 col-sm-6 col-12
                  hoteleria__col
                  px-4
                  mb-2
                "
              >
                <router-link to="/hoteleria" class="hoteleria__link">
                  <div class="row hoteleria__row">
                    <div
                      class="col-12 text-start hoteleria__cuadro-link px-3 py-4"
                      @mouseover="updateHoverState('3')"
                      @mouseleave="updateHoverState('')"
                      :style="{
                        'background-color':
                          hovered_id == '3' ? colorPrimario : '#fff',
                      }"
                    >
                      <p class="hoteleria__titulo-link mb-0">Amonestaciones</p>
                      <p class="hoteleria__texto-link mb-1">
                        Recambio de toallas o ropa corporativa
                      </p>
                    </div>
                  </div>
                </router-link>
              </div>
              <!-- fin Loop de tarjeta de hoteleria -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODALES loop -->

    <!-- MODALES loop -->
  </div>
  <!-- fin HOTELERÍA -->
</template>

<script>
import IconHome from "../../../assets/img/intranet/NavVertical/IconHome.vue";
// @ is an alias to /src

export default {
  components: { IconHome },
  name: "Hoteleria",
  data() {
    return {
      hovered_id: "",
      default_color: "#fff",
    };
  },
  methods: {
    updateHoverState(id_) {
      this.hovered_id = id_;
      console.log(this.hovered_id);
    },
  },
};
</script>